module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-new-check-circle-icon.3749ac18.svg";